import { render, staticRenderFns } from "./RegistrantListTable.vue?vue&type=template&id=fbf5c9a6"
import script from "./RegistrantListTable.vue?vue&type=script&lang=js"
export * from "./RegistrantListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports